
import dust from "dustjs-linkedin";


(function(){dust.register("debug/auto-play-stop",body_0);function body_0(chk,ctx){return chk.write("<div class=\"auto-play-stop\"><button class=\"stop-auto-play\">Stop auto play</button></div>");}return body_0;})();

export default 0;
